var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.currentMallType != 1
        ? _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _vm.roleObj.sptj
                ? _c("el-tab-pane", {
                    attrs: { label: "商品统计", name: "first" }
                  })
                : _vm._e(),
              _vm.roleObj.xfqtj && _vm.currentSysm != 2 && _vm.currentSysm != 3
                ? _c("el-tab-pane", {
                    attrs: { label: "券统计", name: "second" }
                  })
                : _vm._e(),
              _vm.roleObj.ygtj && _vm.currentSysm != 2 && _vm.currentSysm != 3
                ? _c("el-tab-pane", {
                    attrs: { label: "员工统计", name: "third" }
                  })
                : _vm._e(),
              _vm.activeName === "first" && _vm.roleObj.sptj
                ? _c("Statistics")
                : _vm._e(),
              _vm.activeName === "second" &&
              _vm.roleObj.xfqtj &&
              _vm.currentSysm != 2 &&
              _vm.currentSysm != 3
                ? _c("ConsumerCoupon")
                : _vm._e(),
              _vm.activeName === "third" &&
              _vm.roleObj.ygtj &&
              _vm.currentSysm != 2 &&
              _vm.currentSysm != 3
                ? _c("Employee")
                : _vm._e(),
              !_vm.roleObj.sptj && !_vm.roleObj.xfqtj && !_vm.roleObj.ygtj
                ? _c("el-empty", {
                    attrs: {
                      "image-size": 400,
                      description: "您暂无权限查看，请联系管理员增加权限"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _vm.roleObj.sptj
                ? _c("el-tab-pane", {
                    attrs: { label: "商品统计", name: "first" }
                  })
                : _vm._e(),
              _c("el-tab-pane", {
                attrs: { label: "活动统计", name: "second" }
              }),
              _c("el-tab-pane", {
                attrs: { label: "领券统计", name: "third" }
              }),
              _vm.activeName === "first" && _vm.roleObj.sptj
                ? _c("GoodsStatistics")
                : _vm._e(),
              _vm.activeName === "second" ? _c("ActivityStatistics") : _vm._e(),
              _vm.activeName === "third" ? _c("GetGouponsStatistics") : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }